import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
}

function getAreas() {
    return $.Deferred(function(def) {
        dataaccess.get({ url: "/api/area/availableareas" }).done(function(result) {
            def.resolve(result);
        });
    });
}

function getAreaName(area) {
    let areaDescriber = "";
    if (area !== undefined) {
        if (area.name !== null && area.name !== "") areaDescriber = area.name;
        else if (area.state !== null) areaDescriber = area.state.name;
        else if (area.country !== null) areaDescriber = area.country.name;
    }
    return areaDescriber;
}

export const areas = {
    init: init,
    getAreas: getAreas,
    getAreaName: getAreaName
};